export default "__VITE_ASSET__d52c2e93__"